import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import { useApi } from "../../../../../hooks/useApi";
import LineBtn from "../../../../Button/LineBtn";
import { Input } from "../../../../Input/Input";

interface SCommentTargetContainer {
  isFlexStart?: boolean;
}

interface TargetContainerProps extends SCommentTargetContainer {
  targetUid: string;
  setTargetUid: Dispatch<SetStateAction<string>>;
  modalType?: string;
  inputBoxWidth?: number;
  targetText?: string;
}

export default function TargetContainer({
  targetUid,
  setTargetUid,
  modalType,
  isFlexStart,
  inputBoxWidth,
  targetText,
}: TargetContainerProps) {
  const [searchTargetBtnClick, setSearchTargetBtnClick] = useState(false);
  const [searchTargetError, setSearchTargetError] = useState<any>(null);

  const { response, error } = useApi({
    method: "get",
    url: searchTargetBtnClick ? `user/info/${targetUid}` : undefined,
  });

  useEffect(() => {
    if (response && response?.status === 200) {
      setSearchTargetBtnClick(false);
      setTargetUid(
        `${response?.data?.uid}_${response?.data?.name}_${response?.data?.nickname}`
      );
    }
  }, [response, setTargetUid]);

  useEffect(() => {
    if (
      searchTargetError &&
      searchTargetError?.code &&
      searchTargetError?.data
    ) {
      toast.error(`${searchTargetError.data}`, {
        onClose: () => {
          setSearchTargetBtnClick(false);
          setSearchTargetError(null);
        },
      });
    }
  }, [searchTargetError]);

  useEffect(() => {
    if (error) {
      setSearchTargetError(error);
    }
  }, [error]);

  return (
    <Row>
      <ModalLabel>{targetText ?? "대상"}</ModalLabel>

      <CommentTargetContainer isFlexStart={isFlexStart}>
        <Input
          placeholder="직접 입력(UID)"
          value={targetUid}
          inputMode="numeric"
          onChange={(e) => setTargetUid(String(e.target.value))}
          readOnly={targetUid?.includes("_")}
          type="text"
          style={{ width: inputBoxWidth ?? "100%" }}
        />
        <LineBtn
          btnText={targetUid?.includes("_") ? "삭제" : "조회"}
          btnHeight={38}
          disabled={targetUid === "" || modalType === "view"}
          btnClickEvent={() => {
            if (targetUid?.includes("_")) {
              setTargetUid("");
              setSearchTargetBtnClick(false);
              setSearchTargetError(null);
            } else {
              setSearchTargetBtnClick(true);
            }
          }}
        />
      </CommentTargetContainer>
    </Row>
  );
}

const Row = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 12px;
  }
`;

export const ModalLabel = styled.label`
  width: 106px;
  height: 38px;
  display: flex;
  align-items: center;

  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-align: left;
  color: #858c97;
`;

export const CommentTargetContainer = styled.div<SCommentTargetContainer>`
  width: calc(100% - 106px);
  display: flex;
  align-items: center;
  justify-content: ${({ isFlexStart }) =>
      isFlexStart ? "flex-start" : "flex-end"}
    flex-end;
  gap: 10px;
`;
